(function () {
  "use strict";

  var VERSION = "1.0.0";
  var STORAGE_KEY = "lumira_attribution_v1";
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var FIELDS = [
    "click_id",
    "click_type",
    "campaign_id",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "landing_path",
    "referrer_host",
    "captured_at",
  ];
  var running = false;

  function setStatus(status) {
    if (document.documentElement) {
      document.documentElement.setAttribute("data-lumira-attribution", status);
      document.documentElement.setAttribute(
        "data-lumira-attribution-version",
        VERSION,
      );
    }
  }

  function clean(value, limit) {
    if (value === null || value === undefined) return "";
    return String(value)
      .replace(/[\u0000-\u001f\u007f]/g, "")
      .slice(0, limit || 240);
  }

  function lower(value) {
    return clean(value).toLowerCase();
  }

  function getReferrerHost() {
    if (!document.referrer) return "";
    try {
      return clean(new URL(document.referrer).hostname, 120);
    } catch (_error) {
      return "";
    }
  }

  function readPaidTouch(locationLike) {
    var url;
    try {
      url = new URL(locationLike.href);
    } catch (_error) {
      return null;
    }

    var params = url.searchParams;
    var clickType = ["gclid", "gbraid", "wbraid"].find(function (key) {
      return Boolean(params.get(key));
    });
    var utmSource = lower(params.get("utm_source"));
    var utmMedium = lower(params.get("utm_medium"));
    var paidMedium =
      /^(cpc|ppc|paid|paid_search|paidsearch|shopping|display|pmax|performance_max)$/.test(
        utmMedium,
      );
    var campaignId = params.get("gad_campaignid") || params.get("utm_id") || "";
    var isPaidGoogle = Boolean(
      clickType ||
        campaignId ||
        (utmSource.indexOf("google") !== -1 && paidMedium),
    );

    if (!isPaidGoogle) return null;

    return {
      click_id: clickType ? clean(params.get(clickType), 180) : "",
      click_type: clickType || "",
      campaign_id: clean(campaignId, 120),
      utm_source: clean(params.get("utm_source"), 120),
      utm_medium: clean(params.get("utm_medium"), 120),
      utm_campaign: clean(params.get("utm_campaign"), 180),
      utm_term: clean(params.get("utm_term"), 180),
      utm_content: clean(params.get("utm_content"), 180),
      landing_path: clean(url.pathname, 220),
      referrer_host: getReferrerHost(),
      captured_at: new Date().toISOString(),
    };
  }

  function cartTouch(attributes, prefix) {
    attributes = attributes || {};
    var touch = {};
    var found = false;
    FIELDS.forEach(function (field) {
      var value = clean(attributes["lumira_" + prefix + "_" + field]);
      touch[field] = value;
      if (value) found = true;
    });
    return found ? touch : null;
  }

  function encodeAttributes(first, latest) {
    var attributes = { lumira_attribution_schema: "v1" };
    [
      ["first", first],
      ["latest", latest],
    ].forEach(function (entry) {
      var prefix = entry[0];
      var touch = entry[1] || {};
      FIELDS.forEach(function (field) {
        attributes["lumira_" + prefix + "_" + field] = clean(touch[field]);
      });
    });
    return attributes;
  }

  function emptyAttributes() {
    var attributes = { lumira_attribution_schema: "" };
    ["first", "latest"].forEach(function (prefix) {
      FIELDS.forEach(function (field) {
        attributes["lumira_" + prefix + "_" + field] = "";
      });
    });
    return attributes;
  }

  function readState() {
    try {
      var state = JSON.parse(
        window.localStorage.getItem(STORAGE_KEY) || "null",
      );
      if (!state || !state.savedAt || Date.now() - state.savedAt > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return state;
    } catch (_error) {
      return null;
    }
  }

  function saveState(state) {
    try {
      state.savedAt = Date.now();
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_error) {
      // Attribution still remains on the Shopify cart when storage is unavailable.
    }
  }

  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;
    try {
      if (typeof privacy.marketingAllowed === "function")
        return privacy.marketingAllowed();
      if (typeof privacy.currentVisitorConsent === "function") {
        return privacy.currentVisitorConsent().marketing === "yes";
      }
    } catch (_error) {
      return null;
    }
    return null;
  }

  function cartUrl(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + path;
  }

  function getCart() {
    return fetch(cartUrl("cart.js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart read failed");
      return response.json();
    });
  }

  function updateCart(attributes) {
    return fetch(cartUrl("cart/update.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart attribution update failed");
      return response.json();
    });
  }

  function syncAttribution() {
    if (running || marketingAllowed() !== true) return Promise.resolve(false);
    var current = readPaidTouch(window.location);
    var stored = readState();
    if (!current && !stored) {
      setStatus("idle");
      return Promise.resolve(false);
    }

    running = true;
    setStatus("syncing");
    return getCart()
      .then(function (cart) {
        var sameCart = stored && stored.cartToken === cart.token;
        var first = sameCart
          ? stored.first
          : cartTouch(cart.attributes, "first");
        var latest = sameCart
          ? stored.latest
          : cartTouch(cart.attributes, "latest");

        if (current) {
          first = first || current;
          latest = current;
        }
        if (!first && !latest) {
          window.localStorage.removeItem(STORAGE_KEY);
          return false;
        }

        saveState({ cartToken: cart.token, first: first, latest: latest });
        return updateCart(encodeAttributes(first, latest)).then(function () {
          setStatus(
            (latest && latest.click_id) || (first && first.click_id)
              ? "synced-click-id"
              : "synced-campaign",
          );
          document.dispatchEvent(
            new CustomEvent("lumira:attribution-synced", {
              detail: {
                version: VERSION,
                hasClickId: Boolean(
                  (latest && latest.click_id) || (first && first.click_id),
                ),
                hasCampaignId: Boolean(
                  (latest && latest.campaign_id) ||
                    (first && first.campaign_id),
                ),
              },
            }),
          );
          return true;
        });
      })
      .catch(function () {
        setStatus("error");
        return false;
      })
      .finally(function () {
        running = false;
      });
  }

  function removeAttribution() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_error) {
      // Continue and attempt to clear the cart record.
    }
    return updateCart(emptyAttributes())
      .then(function () {
        setStatus("consent-denied");
        return true;
      })
      .catch(function () {
        setStatus("error");
        return false;
      });
  }

  function handleConsent() {
    var allowed = marketingAllowed();
    if (allowed === true) syncAttribution();
    if (allowed === false) removeAttribution();
  }

  if (window.__LUMIRA_ATTRIBUTION_TEST__) {
    window.__LUMIRA_ATTRIBUTION_TEST__.api = {
      readPaidTouch: readPaidTouch,
      cartTouch: cartTouch,
      encodeAttributes: encodeAttributes,
      emptyAttributes: emptyAttributes,
      fields: FIELDS.slice(),
    };
    return;
  }

  document.addEventListener("visitorConsentCollected", handleConsent);
  setStatus("waiting-for-consent");
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleConsent, {
      once: true,
    });
  } else {
    handleConsent();
  }

  var attempts = 0;
  var privacyWait = window.setInterval(function () {
    attempts += 1;
    if (marketingAllowed() !== null || attempts >= 20) {
      window.clearInterval(privacyWait);
      handleConsent();
    }
  }, 250);
})();
